import React from 'react';

import { EmailIcon } from '../../../assets/icons';
import GoogleLoginButton from '../../GoogleLoginButton';

const AlertTriggerLogin = ({ baseURL, authURL, refetchUser }) => {
  return (
    <div className="container_alert_trigger">
      <div className="container_alert_description">
        <p className="text_description">Garanta descontos exclusivos e encontre os menores preços do mercado!</p>
      </div>
      <div className="container_auth_social">
        <GoogleLoginButton label="Acessar com o Google" refetchUser={refetchUser} />
      </div>
      <a
        href={`${baseURL}/area-do-cliente/login?redirect=${encodeURIComponent(window.location.href)}`}
        className="button_email"
      >
        <EmailIcon />
        Acessar com e-mail
      </a>
    </div>
  );
};

export default AlertTriggerLogin;



// WEBPACK FOOTER //
// ./src/components/trigger_auth/alertTrigger/AlertTrigger.jsx